export const sendContactQuery = (name, email, contact, message, subject) => {
  return fetch("http://industrialcalculator.com/api/Values2/QuerySend", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name: name,
      email: email,
      contactno: contact,
      subject: subject,
      message: message,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data && data.message) {
        return data.message;
      } else {
        return "Message not available";
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      return "Failed to send query due to a technical issue.";
    });
};
